angular.module('homebot.directives')

  .directive('nightlyRentalsStaticSection', ['APP_CONFIG', 'DataService', function(APP_CONFIG, DataService){
    return {
      restrict: 'A',
      controllerAs: 'nightlyStaticCtrl',
      bindToController: {
        agent: '=',
        loans: '=',
        home: '='
      },
      scope: {},
      templateUrl: '/homes/templates/partials/nightly-rentals-static.html',

      controller: function(){
        let ctrl = this;
        ctrl.rentalNights = 5;
      }
    }

  }]);
